/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 03 2023
 **/

import { Button, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T, _P } from "@rfice/language";
import { EventHandler } from "@rfice/eventhandler";
import { useSpace } from "@/frameworks/core/API";
import { EventID } from "@/frameworks/core/commons";

import { ModalID } from "@/frameworks/core/commons";
import * as S from "./emotion";
import { nameOverflowStyle } from "./emotion";

export default function GroupAloneSpaceManager({
	groupID,
	spaces
}: {
	groupID: string;
	spaces: SwaggerModels.MySpaceResponseVO[];
}) {
	const modal = useModal();
	const spaceAPI = useSpace();

	const handleCancel = () => {
		EventHandler.emit(EventID.OPEN_MANAGE_SPACE_MEMBER, { spaceInfo: spaces[0] });
		modal.hide(ModalID.GROUP_ALONE_SPACE_MANAGER);
	};

	const handleLeave = () => {
		// TODO space 전체삭제관련하여 api 받으면 수정되어야함
		spaces.forEach((item) => {
			spaceAPI.delete.execute({ groupId: groupID, spaceId: item.spaceId });
		});
		modal.hide(ModalID.GROUP_ALONE_SPACE_MANAGER);
	};

	const message = _T("#{{spaceName}}#의 유일한 관리자입니다.", {
		spaceName: spaces.map((item) => item.spaceName)
	}).split("#");
	return (
		<S.Wrapper gap={10} horizonAlign="center">
			<S.Body horizonAlign="center">
				<Typography.p css={nameOverflowStyle} typoSize="Title1_B">
					{message[0]}
				</Typography.p>
				<Typography.p typoSize="Body2">{message[1]}</Typography.p>
				<Typography.p typoSize="Body2">
					{_P("스페이스의 관리자를 지정하거나<br />스페이스 전체 삭제로 스페이스 전체 삭제 가능합니다.")}
				</Typography.p>

				<S.ErrorTypo>{_T("(데이터는 모두 삭제 되어 복구 불가)")}</S.ErrorTypo>
			</S.Body>
			<S.Footer horizonAlign="center" verticalAlign="center">
				<Button.Group>
					<Button filled="secondary" onClick={handleLeave}>
						{_T("스페이스 전체 삭제")}
					</Button>
					<Button onClick={handleCancel}>{_T("스페이스 관리자 이관")}</Button>
				</Button.Group>
			</S.Footer>
		</S.Wrapper>
	);
}
